import Hero from "./Hero";
import OurStory from "./OurStory";
import WhatWeDo from "./WhatWeDo";
import Slider from "./Slider";
import LatestNews from "./LatestNews";
import { useTranslation } from "react-i18next";
// import EREIGNIS from "./EREIGNIS";
import groupImg from "../../assets/meeting.jpg"
import attImg from "../../assets/attorney.jpg"

function Home() {
  const { t } = useTranslation("home");
  return (
    <div>
      <Hero />
      <OurStory
        our={t("our")}
        title={t("title1")}
        content={t("story1")}
        image={groupImg}
      />
      <WhatWeDo />
      <Slider />
      <OurStory
        our={t("become")}
        title={t("title")}
        content={t("story")}
        image={groupImg}
      />
      <LatestNews />
      {/* <EREIGNIS /> */}
    </div>
  );
}

export default Home;
